import React, { useState } from 'react';

import { PlusIcon } from '../../../../components/common';
import { formatMultilineText } from '../../../../formatters';
import { cn } from '../../../../utils';
import { questions } from '../../../../utils/pages';
import styles from './WithdrawFAQ.module.scss';

const WithdrawFAQ = () => {
  const [activeIndexes, setActiveIndexes] = useState<Array<number>>([]);

  const isIndexActive = (index: number): boolean => {
    return activeIndexes.includes(index);
  };

  const toggleIndex = (index: number): void => {
    if (isIndexActive(index)) {
      setActiveIndexes(activeIndexes.filter((item) => item !== index));
      return;
    }
    setActiveIndexes([...activeIndexes, index]);
  };

  return (
    <ul className={styles.list}>
      {questions.map((item) => {
        const active = isIndexActive(item.id);

        return (
          <li key={item.id} className={styles.item}>
            <button
              type="button"
              className={styles.header}
              onClick={() => toggleIndex(item.id)}
              aria-expanded={active}
            >
              <span className={styles.question}>{item.question}</span>
              <PlusIcon
                size={20}
                preset="success"
                className={cn(styles.icon, active && styles.iconActive)}
              />
            </button>
            <div className={cn(styles.answer, active && styles.answerActive)}>
              <div
                className={styles.content}
                dangerouslySetInnerHTML={{ __html: formatMultilineText(item.answer) }}
              />
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default WithdrawFAQ;
